import { Box, GameButton, HeaderPrimary, Paper } from '@fedsim/components'
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"
import { NOOP } from '@fedsim/helpers'

import Error from 'components/error'

import { getComponent } from './types'

const Row = ({ name, control = {}, Form = {}, onChange = NOOP }) => {
  const { component, label } = Form[name]
  const Component = getComponent(component)
  const rules = Form[name]?.rules
  const props = Form[name]?.props || {}

  return (
    <Component
      label={label}
      name={name}
      control={control}
      onChange={onChange}
      rules={rules}
      props={props}
    />
  )
}

export const FormUI = ({
  title = null,
  submitLabel = 'Submit',
  onSubmit = NOOP,
  onChange = NOOP,
  onReset = NOOP,
  control = {},
  Form = {}
}) => {
  const FormKeys = Object.keys(Form)
  return (
    <>
      {title && <HeaderPrimary>{title}</HeaderPrimary>}
      <Paper
        sx={{
          borderRadius,
          display: 'grid',
          gridRowGap: 6,
          p: 1
        }}
      >
        <Error>
          {FormKeys.map(name => (
            <Row
              key={name}
              name={name}
              Form={Form}
              control={control}
              onChange={onChange}
            />
          ))}
        </Error>
        <Box sx={{ position: "fixed", bottom: 0 }} />
        <GameButton
          onClick={onSubmit}
          aria-label="Submit Form"
          color="success"
          variant="contained"
        >
          {submitLabel}
        </GameButton>
        <GameButton
          variant="contained"
          onClick={onReset}
          aria-label="Reset Form"
          color="error"
        >
          Reset Form
        </GameButton>
      </Paper >
    </>
  )
}

export default FormUI
